import React from "react";
import "../../assets/Css/Navbar.css";
import NavLogo from "../../assets/Images/nav-logo.png"
import { Link, useLocation, useNavigate } from "react-router-dom";

const Navbar = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleButtonClick = () => {
        if (location.pathname === '/records') {
            navigate('/buy-sell-signal');
        } else {
            // Navigate to /records
            navigate('/records');
        }
    };

    return (

        <div
            className="trading-view-header"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "#0096a9",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                margin: '20px'
            }}
        >

            <div
                className="trading-view-title m-0"
                style={{
                    // flex: 1,               
                    // textAlign: "left", 
                    fontWeight: "bold",
                    fontSize: "22px",
                    // color: "#fff"
                }}
            >
                TradingView - Equity and F&O Analysis Tool
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
                <Link
                    to={location.pathname == "/" ? '/buy-sell-signal' : '/'}
                    className="navigate-button"
                    style={{
                        background: "#fff",
                        color: "#0096a9",
                        border: "2px solid #0096a9",
                        borderRadius: "5px",
                        padding: "8px 16px",
                        cursor: "pointer",
                        fontWeight: 'bold',
                        textDecoration: 'none'
                    }}
                >
                    {location.pathname == "/" ? 'Scanner' : 'Back to Home'}
                    {/* Get F/O By Buy Sell Signals  */}
                </Link>

                <button
                    onClick={handleButtonClick}
                    style={{
                        background: "#fff",
                        color: "#0096a9",
                        border: "2px solid #0096a9",
                        borderRadius: "5px",
                        padding: "8px 16px",
                        cursor: "pointer",
                        fontWeight: 'bold'
                    }}
                >
                    {location.pathname === "/records" ? "Scanner" : "View Records"}
                </button>
            </div>
        </div>

    );
};

export default Navbar;
